import { __exports as variant } from "../../../../../../_virtual/variant.js";
var hasRequiredVariant;
function requireVariant() {
  if (hasRequiredVariant) return variant;
  hasRequiredVariant = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", { value: true });
    exports$1.evaluationVariantsToVariants = exports$1.evaluationVariantToVariant = exports$1.filterDefaultVariants = void 0;
    const filterDefaultVariants = (variants) => {
      var _a, _b;
      const results = {};
      for (const flagKey in variants) {
        const variant2 = variants[flagKey];
        const isDefault = (_a = variant2 === null || variant2 === void 0 ? void 0 : variant2.metadata) === null || _a === void 0 ? void 0 : _a.default;
        const isDeployed = ((_b = variant2 === null || variant2 === void 0 ? void 0 : variant2.metadata) === null || _b === void 0 ? void 0 : _b.deployed) || true;
        if (!isDefault && isDeployed) {
          results[flagKey] = variant2;
        }
      }
      return results;
    };
    exports$1.filterDefaultVariants = filterDefaultVariants;
    const evaluationVariantToVariant = (evaluationVariant) => {
      let stringValue;
      if (typeof evaluationVariant.value === "string") {
        stringValue = evaluationVariant.value;
      } else if (evaluationVariant.value !== null && evaluationVariant.value !== void 0) {
        stringValue = JSON.stringify(evaluationVariant.value);
      }
      return Object.assign(Object.assign({}, evaluationVariant), { value: stringValue });
    };
    exports$1.evaluationVariantToVariant = evaluationVariantToVariant;
    const evaluationVariantsToVariants = (evaluationVariants) => {
      const variants = {};
      Object.keys(evaluationVariants).forEach((key) => {
        variants[key] = (0, exports$1.evaluationVariantToVariant)(evaluationVariants[key]);
      });
      return variants;
    };
    exports$1.evaluationVariantsToVariants = evaluationVariantsToVariants;
  })(variant);
  return variant;
}
export {
  requireVariant as __require
};
//# sourceMappingURL=variant.js.map
